module.exports = "<aside>\n  <h1>{{name}}</h1>\n\n  <app-navigation [pages]=\"pages\"></app-navigation>\n</aside>\n\n<router-outlet></router-outlet>\n"